import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

export const useReviewStore = defineStore('review', () => {
  const review = ref<any>(null)
  const userReviews = ref<any>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)
  
  const fetchLatestReview = async (taskId: number) => {
    isLoading.value = true
    error.value = null

    try {
      const response = await api.get(API_ROUTES.GET_LATEST_REVIEW(taskId))
      review.value = response.data
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch latest review'
      console.error('Error fetching latest review:', err)
    } finally {
      isLoading.value = false
    }
  }

  const fetchUserReviews = async (userId: number) => {
    isLoading.value = true
    error.value = null

    try {
      const response = await api.get(API_ROUTES.GET_USER_REVIEWS(userId))
      userReviews.value = response.data
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch user reviews'
      console.error('Error fetching user reviews:', err)
    } finally {
      isLoading.value = false
    }
  }

  return {
    review,
    isLoading,
    error,
    fetchLatestReview,
    fetchUserReviews,
    userReviews
  }
})